export default "__VITE_ASSET__CiZBhcBX__"